import React, { CSSProperties } from 'react'
import { DashboardWidgetType } from 'features/dashboard/types'
import { getLabel } from 'utils/widgetTypeUtil'
import { WidgetType } from 'enums'
import { StyledHeader, HeaderContainer } from './index.css'
import ActionButtons from './ActionButtons'

interface HeaderProps {
  widgetSetting: DashboardWidgetType
  headerContainerStyle: CSSProperties
}

const Header = ({ widgetSetting, headerContainerStyle }: HeaderProps) => {
  const hasActionButtons = ![WidgetType.HTML, WidgetType.RICH_TEXT, WidgetType.TEXT].includes(
    widgetSetting.type!
  )
  return (
    <StyledHeader>
      <HeaderContainer style={headerContainerStyle}>
        {widgetSetting.name || getLabel(widgetSetting.type)}
      </HeaderContainer>
      {hasActionButtons && <ActionButtons widgetSetting={widgetSetting} />}
    </StyledHeader>
  )
}

export default Header
